import { objToKeyPairs } from "@repo/models";
import { DropDownList } from "@repo/ui";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import AuditApi from "../../api/auditApi";
import { Props } from "./types";

function AuditTypeSelector(props: Props) {
	const codes = props.code.split(",");

	const definitionsQuery = useQuery({
		queryKey: ["Definitions", codes],
		queryFn: async () => {
			const defs = [];
			for (const code of codes) {
				const def = await AuditApi.loadDefinition(code);

				const parsedValues = JSON.parse(def.ParamDefinitionJson as any);
				def.ParamDefinition = objToKeyPairs(parsedValues).values();

				defs.push(def);
			}
			return defs;
		},
	});

	function updateDefinition(value: string) {
		const def = definitionsQuery.data.filter((d) => d.Code === value)[0];
		props.setDefinition(def);
	}

	useEffect(() => {
		if (codes.length < 2 && definitionsQuery.data?.length < 2) {
			props.setDefinition(definitionsQuery.data[0]);
		}
	}, [codes, definitionsQuery.data]);

	if (codes.length < 2) return null;

	return (
		<DropDownList
			label=""
			id="auditTypeSelector"
			values={definitionsQuery.data ?? []}
			value={props.definition?.Code}
			changeHandler={updateDefinition}
			selectIfSingle
			valueProp="Code"
			textProp="Name"
		/>
	);
}

export default AuditTypeSelector;
